import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { Stethoscope, LogOut, FileText, Plus, ExternalLink, Mail } from "lucide-react";
import { clearToken } from "@/lib/api";

export default function AdminLayout() {
  const navigate = useNavigate();
  const logout = () => {
    clearToken();
    navigate("/admin/login");
  };
  return (
    <div className="min-h-screen flex flex-col bg-paper-50" data-testid="admin-layout">
      <header className="bg-ink text-paper-50 border-b border-ink/30">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-2.5 group" data-testid="admin-logo">
            <span className="flex items-center justify-center w-8 h-8 rounded-sm bg-forest text-paper-50">
              <Stethoscope className="w-4 h-4" strokeWidth={2.2} />
            </span>
            <span className="font-display font-black text-base tracking-tight leading-none">
              The STEM Vet<span className="text-terracotta">.</span>{" "}
              <span className="text-paper-200/60 font-medium">admin</span>
            </span>
          </Link>
          <nav className="flex items-center gap-2">
            <NavLink
              to="/admin"
              end
              data-testid="admin-nav-posts"
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-sm transition-colors ${
                  isActive ? "bg-forest text-paper-50" : "text-paper-200/80 hover:text-paper-50"
                }`
              }
            >
              <FileText className="w-4 h-4" /> Posts
            </NavLink>
            <NavLink
              to="/admin/new"
              data-testid="admin-nav-new"
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-sm transition-colors ${
                  isActive ? "bg-forest text-paper-50" : "text-paper-200/80 hover:text-paper-50"
                }`
              }
            >
              <Plus className="w-4 h-4" /> New
            </NavLink>
            <NavLink
              to="/admin/newsletter"
              data-testid="admin-nav-newsletter"
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-sm transition-colors ${
                  isActive ? "bg-forest text-paper-50" : "text-paper-200/80 hover:text-paper-50"
                }`
              }
            >
              <Mail className="w-4 h-4" /> Newsletter
            </NavLink>
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-paper-200/70 hover:text-paper-50"
              data-testid="admin-nav-site"
            >
              <ExternalLink className="w-4 h-4" /> View site
            </a>
            <button
              onClick={logout}
              data-testid="admin-logout"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-terracotta hover:bg-paper-50/10 rounded-sm transition-colors"
            >
              <LogOut className="w-4 h-4" /> Logout
            </button>
          </nav>
        </div>
      </header>
      <main className="flex-1 max-w-6xl mx-auto w-full px-5 sm:px-8 py-10">
        <Outlet />
      </main>
    </div>
  );
}
